import axios from "axios";

import store from "@/store";

import { LOGOUT } from "@/store/actions";

// Configure Axios Defaults
// axios.defaults.baseURL = "https://pcnzapi.mcdonnell.co.nz/api/";
// axios.defaults.baseURL = "https://pcnzapidev1.localtunnel.me/api/";
// axios.defaults.baseURL = "https://pcnzapidev.localtunnel.me/api/";
// axios.defaults.baseURL = "https://pcnzdevapi.localtunnel.me/api/";

import localStore from "store2";

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

let token;
try {
  token = JSON.parse(new URL(window.location).searchParams.get("token")).id;
} catch (e) {
  console.warn("Default axios token not found in url: ", e);
}

if (!token) {
  token = localStore("vuex")?.auth?.token;
}

console.log("initing axios with token: ", token);
if (token) {
  axios.defaults.headers.common["Authorization"] = token;
  // store.dispatch("AUTH_TEST");
}

axios.interceptors.response.use(undefined, function(err) {
  return new Promise(function(resolve, reject) {
    if (
      err &&
      err.response &&
      err.response.status === 401 &&
      err.config &&
      !err.config.__isRetryRequest
    ) {
      store.dispatch(LOGOUT);
    }
    throw err;
  });
});

axios.interceptors.response.use(undefined, async function(err) {
  try {
    if (!err.response.data.error.message) {
      throw err;
    }
    let message = err.response.data.error.message;
    err.message = message;
    /* eslint-ignore */
  } catch (e) {}
  throw err;
});

export default axios;
